import React from "react";
import { useSelector } from "react-redux";
import { boldEn1,  downloadCvEn, h4En1, h4En4, h4En5, pEn10, pEn11,  pEn4,  pEn8, pEn9 } from "../../translate/english";
import { boldEs1,  downloadCvEs, h4Es1, h4Es4, h4Es5, pEs10, pEs11, pEs4,  pEs8, pEs9 } from "../../translate/spanish";
import {
  A,
  Bold,
  BoxProfile,
  Download,
  DownloadButton,
  H4,
  Li,
  P,
  ProfileContainer,
  ProfileFather,
  Ul,
} from "./ProfileBodyStyles";


import scrollTop from "../../utilities/scrollTop";

function ProfileBody() {
  scrollTop()
  const language = useSelector(state => state.language.english)
  return (
    <>
    <div style={{backgroundColor:'transparent', width:'100%', height:'20px'}}></div>
    <ProfileContainer className="fade-in">
      <ProfileFather>
        <BoxProfile>
          <H4>{language ? h4En1 : h4Es1}</H4>
          <br />

          <Bold>{language ? boldEn1 : boldEs1}</Bold>
          <P>Cristian Daniel Herrera</P>
          <br />
          <br />
          <Bold>Email: </Bold>
          <P>mail@cristianherrera.co.uk</P>
          <br />
          <br />
          <Bold>Linkedin: </Bold>
          <A
            href="https://ar.linkedin.com/in/cristian-daniel-herrera"
          
          >
            {language ? pEn4 : pEs4}
          </A>
          <br />
          <br />
          <Bold>GitHub: </Bold>
          <A href="https://github.com/cristian-daniel88">
          {language ? pEn4 : pEs4}
          </A>
          <br />
          <br />
          <br />
          <H4>PROFILE</H4>
          <br />
          <P>
            I am an experienced software developer currently working independently, delivering professional website solutions. I have recently obtained the CompTIA A+ certification. I am seeking opportunities in software development or entry-level IT technician roles, where I can continue developing my skills and build a long-term career in technology. I enjoy solving problems, automating tasks, and saving time. I am a highly curious person with a strong interest in IT in general.
          </P>
          <br />
          <br />
          <br />
         
          <H4>WORK EXPERIENCE</H4>
          <br/>
          <Ul style={{'padding': '0 0%'}}>
            <Li>
              GB Logical (UK) Limited POSITION HELD: Software Developer   Aug 2022 – Oct 2022
              I developed web-based solutions, deployed and managed Linux servers, and performed low-level programming (firmware)
            </Li>
            <br/>
            <Li>
              <A href="https://cristianherreraguitar.co.uk">cristianherreraguitar.co.uk</A> : My Business  2020 - Today
              I am a professional musician. I had to create business solutions for myself, 
              such as deploying my own website to promote my services on Google. 
              On this website, there is a contact form for sending emails, a subscription form, 
              testimonials, and a media player with my music.
              I also developed software to generate PDF invoices, 
              as well as other software to record my income and expenses, 
              which I send to my accountant. It is very interesting because I started with a static website, 
              and it has now grown into a large software system that continues to evolve over time.
            </Li>
            <br/>
           {/* <Li>
            Decisive Devices Ltd : It Technician - Web Developer
            At this company, I worked on repairing and upgrading computers,
             and I also developed a software solution for another company. 
           </Li> */}
          </Ul>
          <br/>
          <br/>

        </BoxProfile>

        <BoxProfile>
          <H4>{language ? h4En4 : h4Es4}</H4>
          <br />
          <Ul style={{'padding': '0 10%'}}>
            <Li>
            
            <A href="https://cristianherrera.co.uk/certificates/comptiaaplus.pdf">
            Certified IT Technician with CompTIA A+ | 2025 -  2028:   
            </A> Experienced in troubleshooting, configuring, and maintaining PCs, laptops, and peripherals. 
                 Skilled in user support, resolving technical issues, and ensuring efficient IT operations, 
                 including server configuration, network ports, and Wi-Fi.
            </Li>
            <br/>
            <Li>
            {language ? pEn11 : pEs11}
            </Li>
            <br/>
            <Li>
            {language ? pEn10 : pEs10}
            </Li>
            <br />
            <Li>
            {language ? pEn9 : pEs9}
            </Li>
            <br/>
            <Li>
              {language ? pEn8 : pEs8}
            </Li>
            <br />
          </Ul>
          <br />
          <br />
          <br />

          <H4>{language ? h4En5 : h4Es5} </H4>
          <br />
          <Ul>
            <Li>Git</Li>
            <Li>HTML</Li>
            <Li>CSS</Li>
            <Li>Bootstrap - Tailwind</Li>
            <Li>PHP</Li>
            <Li>Laravel - Simphony - Wordpress</Li>
            <Li>JavaScript - Jquery - TypeScript</Li>
            <Li>NodeJs</Li>
            <Li>React - React Native - Electron - Next.Js</Li>
            <Li>C++</Li>
            <Li>Arduino</Li>
            <Li>MongoDb</Li>
            <Li>SQL</Li>
            <Li>Windows Profesional and Enterprise</Li>
            <Li>Linux - Servers - Raspberry Pi</Li>
            <Li>Docker</Li>
            <Li>Virtual Machines</Li>
          </Ul>
          <br/>
          <br/>
          <br/>
          <DownloadButton>
            <Download href={'https://cristianherrera.co.uk/CristianHerrera CV.pdf'} download>
                {language ? downloadCvEn : downloadCvEs}
                
            </Download>
          </DownloadButton>
        </BoxProfile>
      </ProfileFather>
      <br />
    </ProfileContainer>
    </>
  );
}

export default ProfileBody;
